exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ticketGrpGrid {\n  height: 100%;\n  display: grid;\n  align-items: center;\n  gap: 4px;\n  grid-template-columns: 4fr 2fr;\n  border-radius: 10px;\n}", ""]);

// exports
